// extracted by mini-css-extract-plugin
export default {"legend":"Bna-z","legendSpacing":"Cna-z"};